export default {
  particleChartlet: {
    title: '粒子贴图',
  },
  particlePlay: {
    title: '播放设置',
    cycleIndex: '循环次数',
    startBtn: '开始播放粒子特效',
    stopBtn: '暂停播放粒子特效',
    sequence: '次',
    LoopPlayback: '循环播放',
    playOnAwake: '自动播放',
  },
  particleSetting: {
    particleParameter: '粒子参数',
    particleDynamicParameter: '物理参数',
    overLifespan: '粒子渐变参数',
    changingCurve: '变化曲线',
    zoneType: {
      title: '发射区域',
      detail:
        '支持四种类型：Zone.POINT(点)、Zone.LINE(直线)、Zone.CIRCLE(圆)、Zone.RECTANGLE(矩形)',
    },
    zoneLength: {
      title: '区域长度',
      detail: '发射区域的直线长度',
    },
    zoneRotation: {
      title: '区域旋转',
      detail: '发射区域的直线旋转角度',
    },
    zoneRadius: {
      title: '区域半径',
      detail: '发射区域的圆半径',
    },
    zoneWidth: {
      title: '区域宽度',
      detail: '发射区域的矩形宽度',
    },
    zoneHeight: {
      title: '区域高度',
      detail: '发射区域的矩形高度',
    },
    edgeEmission: {
      title: '发射边缘',
      detail: 'Edge Emission',
    },
    emissionSpace: {
      title: '发射空间',
      detail: '自身坐标系(Local)还是世界坐标系(World)',
    },
    quantity: {
      title: '粒子数量',
      detail: '即每次发射的粒子数量',
    },
    frequency: {
      title: '产生频率',
      detail: '即多久发射一次粒子',
    },
    startScaleMin: {
      title: '最小粒子尺寸',
      detail: '生成的最小粒子尺寸与原粒子的比率',
    },
    startScaleMax: {
      title: '最大粒子尺寸',
      detail: '生成的最大粒子尺寸与原粒子的比率',
    },
    startAlphaMax: {
      title: '最大透明度',
      detail: '生成的粒子最大透明度',
    },
    startAlphaMin: {
      title: '最小透明度',
      detail: '生成的粒子最小透明度',
    },
    startRotationMin: {
      title: '最小旋转角度',
      detail: '生成的粒子最小旋转角度',
    },
    startRotationMax: {
      title: '最大旋转角度',
      detail: '生成的粒子最大旋转角度',
    },
    startVelocityMin: {
      title: '最小速度',
      detail: '生成的粒子最小速度',
    },
    startVelocityMax: {
      title: '最大速度',
      detail: '生成的粒子最大速度',
    },
    lifespanMin: {
      title: '最小生命周期',
      detail: '生成的粒子最小生命周期',
    },
    lifespanMax: {
      title: '最大生命周期',
      detail: '生成的粒子最大生命周期',
    },
    gravityX: {
      title: '速度叠加X',
      detail: 'X方向的重力',
    },
    gravityY: {
      title: '速度叠加Y',
      detail: 'Y方向的重力',
    },
    maxParticles: {
      title: '最大粒子数',
      detail: '当粒子数量超过此值时停止发射粒子',
    },
    delay: {
      title: '发射延迟',
      detail: '延迟发射的粒子时间',
    },
    blendMode: {
      title: '混合模式',
      detail: 'Blend Mode',
    },
    startColor: {
      title: '出生颜色',
      detail: '粒子出生时的颜色',
    },
    startColorVariation: {
      title: '出生颜色浮动',
      detail: '粒子出生时的颜色浮动',
    },
    endColor: {
      title: '死亡颜色',
      detail: '粒子死亡时的颜色',
    },
    endColorVariation: {
      title: '死亡颜色浮动',
      detail: '粒子死亡时的颜色浮动',
    },
    angleMin: {
      title: '最小发射角度',
      detail: '生成的粒子最小发射角度',
    },
    angleMax: {
      title: '最大发射角度',
      detail: '生成的粒子最大发射角度',
    },
    angularVelocityMin: {
      title: '最小角速度',
      detail: '生成的粒子最小角速度',
    },
    angularVelocityMax: {
      title: '最大角速度',
      detail: '生成的粒子最大角速度',
    },
    colorCurve: {
      title: '颜色生命周期',
      detail: '粒子的颜色生命周期曲线',
    },
    alphaCurve: {
      title: '透明度生命周期',
      detail: '粒子的透明度生命周期曲线',
    },
    scaleCurve: {
      title: '尺寸生命周期',
      detail: '粒子的尺寸生命周期曲线',
    },
    velocityCurve: {
      title: '速度生命周期',
      detail: '粒子的速度生命周期曲线',
    },
    angularVelocityCurve: {
      title: '角速度生命周期',
      detail: '粒子的角速度生命周期曲线',
    },
  },
}
